import React, {useState, useEffect, useCallback} from "react";
import PropTypes from "prop-types";
import {getMediaThumbSrc, getMediaFullSrc} from "../../helpers/mediaUrl";


const Gallery = (props) => {

  const {media} = props
  const [lightboxIndex, setLightboxIndex] = useState(null)

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') setLightboxIndex(null)
    if (e.key === 'ArrowLeft') setLightboxIndex(prev => prev > 0 ? prev - 1 : media.length - 1)
    if (e.key === 'ArrowRight') setLightboxIndex(prev => prev < media.length - 1 ? prev + 1 : 0)
  }, [media])

  useEffect(() => {
    if (lightboxIndex !== null) {
      document.addEventListener('keydown', handleKeyDown)
      return () => document.removeEventListener('keydown', handleKeyDown)
    }
  }, [lightboxIndex, handleKeyDown])

  if (!media || media.length === 0) {
    return null
  }

  const handleClose = (e) => {
    if (e.target.classList.contains('gallery-lightbox')) {
      setLightboxIndex(null)
    }
  }

  return (
    <div className="component-gallery">
      <h3>Galerij</h3>
      <div className="gallery-grid">
        {media.map((mediaItem, i) => {
          const src = getMediaThumbSrc(mediaItem)
          if (!src) return null
          return (
            <div
              key={mediaItem.id || i}
              className="gallery-item"
              onClick={() => setLightboxIndex(i)}
            >
              <img
                src={src}
                alt={"Galerij afbeelding " + (i + 1)}
                loading="lazy"
              />
            </div>
          )
        })}
      </div>

      {lightboxIndex !== null &&
        <div className="gallery-lightbox" onClick={handleClose}>
          <div className="lightbox-content">
            <button
              className="lightbox-close"
              onClick={() => setLightboxIndex(null)}
            >
              &times;
            </button>
            <button
              className="lightbox-nav lightbox-prev"
              onClick={(e) => {
                e.stopPropagation()
                setLightboxIndex(lightboxIndex > 0 ? lightboxIndex - 1 : media.length - 1)
              }}
            >
              &#8249;
            </button>
            <img
              src={getMediaFullSrc(media[lightboxIndex])}
              alt={"Galerij afbeelding " + (lightboxIndex + 1)}
            />
            <button
              className="lightbox-nav lightbox-next"
              onClick={(e) => {
                e.stopPropagation()
                setLightboxIndex(lightboxIndex < media.length - 1 ? lightboxIndex + 1 : 0)
              }}
            >
              &#8250;
            </button>
          </div>
        </div>
      }
    </div>
  )
}

Gallery.propTypes = {
  media: PropTypes.array.isRequired,
}

export default Gallery
